import angular from 'angular';
import {
  userService,
  loaderService,
  ssDialogService,
  reportsSharedModelService,
} from 'app/services';
import { actionIcon } from 'app/components/global';

import reportTypes from './reportTypes';

import directive from './my-reports.directive';
import controller from './my-reports.controller';


export const myReportsRouteConfig = {
  template: require('./my-reports.html'),
  controller: 'MyReportsController',
  controllerAs: 'myReportsVM',
};

export default angular.module('app.components.reports.myReports', [
  userService,
  loaderService,
  ssDialogService,
  reportsSharedModelService,
  actionIcon,
  reportTypes,
])
  .directive('myReports', directive)
  .controller('MyReportsController', controller)
  .name;

console.log('app.components.reports.myReports created');
